import { useStatistics } from './StatiscticsContext';
import ArrowRedUpIcon from '@/assets/icons/V3/arrow/ArrowRedUpIcon.svg?react';
import ArrowBlueDownIcon from '@/assets/icons/V3/arrow/ArrowBlueDownIcon.svg?react';

import { autoComma } from '@/utils/parser';
import { BarChart } from '@/components/V3/Chart/BarChart';

interface Props {
  isDashboard?: boolean;
}

const BarChartSection = ({ isDashboard }: Props) => {
  const {
    activedMonthlySales,
    isRegisteredMarket,
    totalSalesAmount,
    monthlySalesList,
    setActivedMonthlySales,
  } = useStatistics();

  const showOverlay = (!isRegisteredMarket || totalSalesAmount === 0) && !isDashboard;

  // 데이터 분기: showOverlay면 목데이터, 아니면 실제 데이터
  const chartMonthlySalesList = showOverlay
    ? MOCK_CHART_MONTHLY_SALES_LIST
    : monthlySalesList.slice(-(monthlySalesList.length - 1));

  const activeSales = showOverlay
    ? MOCK_CHART_MONTHLY_SALES_LIST[MOCK_CHART_MONTHLY_SALES_LIST.length - 1]
    : activedMonthlySales;

  const currentIdx = showOverlay
    ? MOCK_CHART_MONTHLY_SALES_LIST.length - 1
    : monthlySalesList.findIndex((item) => item.Month === activedMonthlySales.Month);

  const prevMonth = showOverlay
    ? MOCK_CHART_MONTHLY_SALES_LIST[currentIdx - 1]
    : monthlySalesList[currentIdx - 1];

  const diff = activeSales.SalesAmount - (prevMonth?.SalesAmount ?? 0);

  return (
    <div className="flex  flex-col gap-4 rounded-[16px] bg-white p-[16px]">
      <div className="flex flex-col gap-2">
        <div className="text-gr-900 Body1S16">매출 추이</div>
        <div className="flex flex-wrap gap-2">
          <div className="text-gr-800 Title3S18">
            {/* {autoComma(activedMonthlySales.SalesAmount)}원 */}
            {autoComma(activeSales.SalesAmount)}원
          </div>
          {activeSales.SalesAmount > 0 && (
            <div
              className={`flex items-center gap-[2px] Caption1M12 ${
                diff >= 0 ? 'text-red-400' : 'text-blue-400'
              }`}
            >
              <span>지난달 같은 기간 보다</span>
              <div className="flex items-center">
                {diff >= 0 ? <ArrowRedUpIcon /> : <ArrowBlueDownIcon />}
                <span>{autoComma(Math.abs(diff))}</span>
              </div>
            </div>
          )}
        </div>
      </div>
      {activeSales.SalesAmount > 0 && (
        <div>
          <BarChart
            PcVersion
            monthlySalesList={chartMonthlySalesList}
            onClickBar={setActivedMonthlySales}
            activedMonthlySales={
              showOverlay
                ? MOCK_CHART_MONTHLY_SALES_LIST[MOCK_CHART_MONTHLY_SALES_LIST.length - 1]
                : activedMonthlySales
            }
          />
        </div>
      )}
    </div>
  );
};

export default BarChartSection;
// 월별 차트용 목데이터 (2025년 1월~6월)
export const MOCK_CHART_MONTHLY_SALES_LIST = [
  {
    FirstDayOfMonth: '2025-01-01T00:00:00',
    Month: '2025-01',
    SalesAmount: 102074912,
    SalesAmountUntilDay: 73583492,
  },
  {
    FirstDayOfMonth: '2025-02-01T00:00:00',
    Month: '2025-02',
    SalesAmount: 95000000,
    SalesAmountUntilDay: 70000000,
  },
  {
    FirstDayOfMonth: '2025-03-01T00:00:00',
    Month: '2025-03',
    SalesAmount: 110500000,
    SalesAmountUntilDay: 80000000,
  },
  {
    FirstDayOfMonth: '2025-04-01T00:00:00',
    Month: '2025-04',
    SalesAmount: 120000000,
    SalesAmountUntilDay: 90000000,
  },
  {
    FirstDayOfMonth: '2025-05-01T00:00:00',
    Month: '2025-05',
    SalesAmount: 105000000,
    SalesAmountUntilDay: 75000000,
  },
  {
    FirstDayOfMonth: '2025-06-01T00:00:00',
    Month: '2025-06',
    SalesAmount: 115000000,
    SalesAmountUntilDay: 85000000,
  },
];
// 총 매출액 목데이터
export const MOCK_SALES_AMOUNT = 648574912;

// 전월 동기간 대비 증감 목데이터
export const MOCK_DIFF = 10000000;
